import { Link } from "react-router-dom";

// Primärer CTA (Petrol), weißer Text (WCAG AA)
export const PrimaryLink = ({ to, href, children, className = "", ...props }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-xl bg-brand px-7 py-4 text-lg font-600 text-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-hover hover:shadow-lg active:translate-y-0 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 ${className}`;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <Link to={to} className={cls} {...props}>{children}</Link>;
};

// Akzent-CTA (Rot), weißer Text (WCAG AA)
export const CoralLink = ({ to, href, children, className = "", ...props }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-xl bg-coral px-7 py-4 text-lg font-600 text-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:bg-coral-hover hover:shadow-lg active:translate-y-0 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-coral/50 ${className}`;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <Link to={to} className={cls} {...props}>{children}</Link>;
};

// Sekundärer Umriss-Button
export const OutlineLink = ({ to, href, children, className = "", ...props }) => {
  const cls = `inline-flex items-center justify-center gap-2 rounded-xl border-2 border-brand bg-white px-7 py-4 text-lg font-600 text-brand shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-light active:translate-y-0 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 ${className}`;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <Link to={to} className={cls} {...props}>{children}</Link>;
};

// Eyebrow-Label über Überschriften
export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-2 rounded-full bg-brand-light px-4 py-1.5 text-sm font-600 uppercase tracking-wide text-brand">
    {children}
  </span>
);

export const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="relative bg-brand-dark text-white overflow-hidden">
    <div
      className="absolute inset-0 opacity-[0.07]"
      style={{
        backgroundImage:
          "radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)",
        backgroundSize: "28px 28px",
      }}
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-5 md:px-10 pt-16 pb-16 md:pt-24 md:pb-20">
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-sm font-600 uppercase tracking-wide text-gold">
          {eyebrow}
        </span>
      )}
      <h1 className="mt-5 text-4xl md:text-5xl lg:text-6xl font-600 leading-tight max-w-3xl">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-5 text-lg md:text-xl text-white/80 max-w-2xl leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);
